export enum LeftMenuTabs {
  PROJECT = 'project',
  PAGE = 'page',
  CSS = 'css',
  ASSETS = 'assets',
  Image = 'image',
  Localization = 'localization',
  Theme = 'theme',
  Font = 'font',
  Templates = 'templates',
  State = 'state',
  ExternalApi = 'externalApi',
  Components = 'components',
}
